import React, { useState, useEffect, useRef } from 'react';

const CATEGORIES = [
  {
    id: 'smileys', icon: '😀', label: 'Smileys',
    emojis: ['😀','😃','😄','😁','😆','😅','😂','🤣','🥲','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🥸','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔','🫡','🤭','🤫','🤥','😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴','🤤','😪','😵','😵‍💫','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕','🤑','🤠','😈','👿','🤡','💩','👻','💀','👽','🤖'],
  },
  {
    id: 'gestures', icon: '👍', label: 'Gestures & people',
    emojis: ['👍','👎','👌','🤌','🤏','✌️','🤞','🫰','🤟','🤘','🤙','👈','👉','👆','👇','☝️','🫵','👋','🤚','🖐️','✋','🖖','👏','🙌','🫶','👐','🤲','🤝','🙏','✍️','💅','🤳','💪','🦾','🖕','🫂','👶','🧒','👦','👧','🧑','👨','👩','🧔','👴','👵','🙋','🤦','🤷','💁','🙅','🙆','🧏','🙇','👮','🕵️','💂','👷','🤴','👸','👳','🦸','🦹','🧙','🧚','🧛','🧟','💃','🕺','👯','🧘','🏃','🚶','🧎'],
  },
  {
    id: 'hearts', icon: '❤️', label: 'Hearts & symbols',
    emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❤️‍🔥','❤️‍🩹','💕','💞','💓','💗','💖','💘','💝','💟','♥️','💯','💢','💥','💫','💦','💨','🕳️','💬','🗨️','💭','💤','✨','⭐','🌟','⚡','🔥','🌈','☀️','🌙','☁️','❄️','💧','🎉','🎊','🎈','🎁','🏆','🥇','🥈','🥉','⚽','🏀','🎮','🎲','🎯','🎵','🎶','🔔','📢','✅','❌','⚠️','❓','❗','💡','🔒','🔑','📌','📍'],
  },
  {
    id: 'animals', icon: '🐶', label: 'Animals & nature',
    emojis: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐻‍❄️','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐒','🐔','🐧','🐦','🐤','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🪲','🦋','🐌','🐞','🐜','🪰','🐢','🐍','🦎','🦂','🦀','🦞','🦐','🦑','🐙','🦈','🐬','🐳','🐋','🐟','🐠','🐡','🐊','🐅','🐆','🦓','🦍','🐘','🦛','🦏','🐪','🦒','🦘','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕','🐩','🦮','🐈','🐓','🦃','🦚','🦜','🦢','🐇','🦝','🦨','🦡','🦫','🦦','🦥','🐁','🐀','🦔','🌵','🎄','🌲','🌳','🌴','🪴','🌱','🌿','☘️','🍀','🍁','🍄','🌾','💐','🌷','🌹','🌺','🌸','🌼','🌻'],
  },
  {
    id: 'food', icon: '🍕', label: 'Food & drink',
    emojis: ['🍏','🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🫒','🧄','🧅','🥔','🍠','🥐','🥯','🍞','🥖','🥨','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🌭','🍔','🍟','🍕','🫓','🥪','🥙','🧆','🌮','🌯','🫔','🥗','🥘','🫕','🥫','🍝','🍜','🍲','🍛','🍣','🍱','🥟','🦪','🍤','🍙','🍚','🍘','🍥','🥠','🥮','🍢','🍡','🍧','🍨','🍦','🥧','🧁','🍰','🎂','🍮','🍭','🍬','🍫','🍿','🍩','🍪','🌰','🥜','☕','🍵','🧃','🥤','🧋','🍶','🍺','🍻','🥂','🍷','🥃','🍸','🍹','🧉','🍾','🧊'],
  },
  {
    id: 'activities', icon: '⚽', label: 'Activities & travel',
    emojis: ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🪀','🏓','🏸','🏒','🥅','⛳','🪁','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛼','🛷','⛸️','🥌','🎿','⛷️','🏂','🪂','🏋️','🤸','🤺','🤾','🏌️','🏇','🧗','🚴','🚵','🤹','🎭','🩰','🎨','🎬','🎤','🎧','🎼','🎹','🥁','🪘','🎷','🎺','🪗','🎸','🪕','🎻','🎲','♟️','🎯','🎳','🎮','🎰','🧩','🚗','🚕','🚙','🚌','🏎️','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🛵','🏍️','🚲','🛴','✈️','🚀','🛸','🚁','⛵','🚤','🛳️','⚓','🚂','🚆','🚇','🗺️','⛺','🏠','🏡','🏢','🏥','🏦','🏨','🏪','🏫','⛪','🕌','🗼','🗽','⛲','🏰','🎡','🎢','🎠','⛱️','🏖️','🏝️','🌋','⛰️','🏔️','🗻'],
  },
];

const RECENT_KEY = 'chat_recent_emojis';
const MAX_RECENT = 24;

function loadRecent() {
  try {
    const arr = JSON.parse(localStorage.getItem(RECENT_KEY));
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}

export default function EmojiPicker({ onPick, onClose }) {
  const [recent, setRecent] = useState(loadRecent);
  const [tab, setTab] = useState(recent.length > 0 ? 'recent' : CATEGORIES[0].id);
  const panelRef = useRef(null);

  // Close when clicking/tapping outside the panel
  useEffect(() => {
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('pointerdown', handler);
    return () => document.removeEventListener('pointerdown', handler);
  }, [onClose]);

  const pick = (emoji) => {
    const next = [emoji, ...recent.filter((e) => e !== emoji)].slice(0, MAX_RECENT);
    setRecent(next);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(next)); } catch {}
    onPick(emoji);
  };

  const activeEmojis = tab === 'recent'
    ? recent
    : CATEGORIES.find((c) => c.id === tab)?.emojis || [];

  return (
    <div
      ref={panelRef}
      className="absolute bottom-full left-0 right-0 z-40 mx-2 mb-2 rounded-2xl border border-white/10 bg-[#1e2433] shadow-2xl"
    >
      {/* Category tabs */}
      <div className="flex items-center gap-1 border-b border-white/5 px-2 py-1.5">
        <button
          onClick={() => setTab('recent')}
          disabled={recent.length === 0}
          aria-label="Recently used"
          className={`rounded-lg px-2 py-1 text-base transition disabled:opacity-25
            ${tab === 'recent' ? 'bg-white/15' : 'hover:bg-white/5'}`}
        >🕘</button>
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            onClick={() => setTab(c.id)}
            aria-label={c.label}
            className={`rounded-lg px-2 py-1 text-base transition
              ${tab === c.id ? 'bg-white/15' : 'hover:bg-white/5'}`}
          >{c.icon}</button>
        ))}
        <button onClick={onClose} aria-label="Close emoji picker"
          className="ml-auto rounded-full p-1.5 text-slate-400 hover:bg-white/10 hover:text-white">
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Emoji grid */}
      <div className="grid max-h-56 grid-cols-8 gap-0.5 overflow-y-auto p-2 sm:grid-cols-10">
        {activeEmojis.map((emoji, i) => (
          <button
            key={`${emoji}-${i}`}
            onClick={() => pick(emoji)}
            className="rounded-lg p-1 text-xl leading-none transition hover:bg-white/10 active:scale-90"
          >{emoji}</button>
        ))}
      </div>
    </div>
  );
}
